<template>
  <div>
    <video 
      ref="videoPlayer" 
      id='videojsPlayer'
      class='video-js vjs-default-skin'
      :class='cls'
      width="800px"
      controls 
      preload="auto"
    >
      <source 
        :src='src' 
        :type='isLive ? "application/x-mpegurl" : "video/mp4"'
      >
    </video>
  </div>
</template>

<script>
import videojs from 'video.js';
import '@videojs/http-streaming';
import { authRequest, isSmallerDevice, log } from '../app/helpers';
import $ from 'jquery';
// FIX: Fix player current time error issue
// 'https://www.w3schools.com/html/mov_bbb.mp4'
export default {
  props: {
    options: {
      type: Object,
      default() {
        return {};
      }
    },
    src: String,
    title: String,
    subtitle: String,
    id: Number,
    time: String,
    type: String,
    autoPlay: {
      type: Boolean,
      default: true
    },
    updatePlayTime: {
      type: Boolean,
      default: true
    },
    updatePlayTimeUrl: {
      type: String,
      default: '/playtime'
    },
    isLive: {
      type: Boolean,
      default: false
    },
  },

  data: () => ({
    player: null,
    oldTime: null,
    timeUpdateTimer: 0,
  }),

  computed: {
    cls() {
      return isSmallerDevice(768) ? "smaller-screen" : "";
    }
  },

  mounted() {
    const self = this;
    
    $(document).ready(() => {
      $('#videojsPlayer').filter(function() {
        $(this).attr('width', $(this).parent().width());
      });

      this.player = videojs(this.$refs.videoPlayer, this.options, function onPlayerReady() {
        log('onPlayerReady', this);  
      });

      this.player.play();

      this.player.on('loadedmetadata', function() {
        self.setInitialTime(this);
      })

      if (this.updatePlayTime) {
        this.player.on('play', () => {
          this.timeUpdateTimer = setInterval(() => {
            this.updateTime(this.player);
          }, 5000)
        });
        
        this.player.on('pause', () => {
          clearInterval(this.timeUpdateTimer);
        });
      }
    })
  },

  beforeDestroy() {
    if (this.player) {
      this.player.dispose()
    }
  },

  methods: {
    async updateTime(player) {
      const self = this;
      
      let pos = player.currentTime();
      let hash = pos && !isNaN(pos) ? 
        "t=" + (Math.round(pos * 10) / 10) : 
        "";
      let duration = player.duration();
      
      log('oldtime', self.oldTime);
      log('hash', hash);

      if (self.oldTime != hash) {
        self.oldTime = hash;
        
        let q = {};
        q.time = hash;
        q.id = self.id;
        q.duration = duration;
        q.type = self.type;

        log('updatetime:', q);

        const req = await authRequest(
          self.$router,
          self.updatePlayTimeUrl,
          q,
          'post'
        );

        log('time updated ', req)
      } else {
        log('removing interval')
        clearInterval(timer)
      }
    },
  
    setInitialTime(player) {
      if (this.time == null || !player) {
        return true;
      }

      let hash = this.time,
          pos = hash.substr(3);

      if (hash.indexOf("#t=") === 0 && !isNaN(pos)) {
        // 1 decimal precision
        pos = Math.round(parseFloat(pos) * 10) / 10;
        player.currentTime(pos); // set initial time here
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.video-js {
  height: 500px;
  
  &.smaller-screen {
    height: 300px;
  }
}
</style>